/**
 * @generated SignedSource<<d05cf218908f98e05584495b821f2b5c>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "userId"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "userId"
                }
            ],
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstname",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastname",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "ImpersonateUserModalQuery",
            "selections": (v1 /*: any*/),
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "ImpersonateUserModalQuery",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "c8a8c4d836c15393306331e4fe3cda4f",
            "id": null,
            "metadata": {},
            "name": "ImpersonateUserModalQuery",
            "operationKind": "query",
            "text": "query ImpersonateUserModalQuery(\n  $userId: ID!\n) {\n  user(id: $userId) {\n    id\n    firstname\n    lastname\n  }\n}\n"
        }
    };
})();
node.hash = "45fdf826bdff423f196ad72aa73012fc";
export default node;
